import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, Pipe, PipeTransform } from '@angular/core';
import { LoginService } from 'src/app/services/login/login.service';
import { SessionService } from 'src/app/services/session/session.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
  selector: 'app-my-journey',
  templateUrl: './my-journey.component.html',
  styleUrls: ['./my-journey.component.scss']
})
export class MyJourneyComponent implements OnInit, AfterViewInit, OnDestroy {

  first_login_details;
  refresh_flag = 1;

  current_step = {
    type: null,
    session: null,
    index: null
  }

  id = (Math.floor((Math.random() * 10000) + 1) + Date.now()).toString();

  max_step_type;

  steps = [];
  step_header_element;

  constructor(
    private http: HttpClient,
    private detector: ChangeDetectorRef,
    private session_service: SessionService,
    private notifcation_svc: NotificationService,
    private login_svc: LoginService,
    private profile_settings: ProfileSettingsService
  ) { }


  ngOnInit() {
    this.session_service.my_journey_details.subscribe(session => {

      if (session) {
        this.first_login_details = session;
        let code = localStorage.getItem('sellerShortCode')
        if (code && code != '') {
          this.getJourneyDetails();
        }
        else {
          this.profile_settings.loadDefaultSettings().subscribe(res => {
            if (res && res['data']) {
              localStorage.setItem('sellerShortCode', res['data'].sellerShortCode);
              this.getJourneyDetails();
            }
          })
        }
      }
    })
    // this.getJourneyDetails(1);
  }

  ngAfterViewInit() {
    // this.step_header_element = document.getElementById('step-headers' + this.id);
    // console.log(this.step_header_element)
    // this.observer().observe(document.getElementById(this.id));

  }

  ngOnDestroy(): void {
    // try {
    //   this.observer().unobserve(document.getElementById(this.id));

    // } catch (error) {

    // }
  }

  setActiveStepper(index, type, step) {

    // if (step.status >= 1 && step.status <= 2) {
    this.current_step.type = type;
    this.current_step.index = index;
    this.setActiveHeader(index);
    // }
    // else {
    //   this.notifcation_svc.error(step.title + " will be enabled as you progress further", "Close", 3000);
    // }
  }

  updateJourenyDetails(ev) {
    if (ev) {
      this.login_svc.firstLogin().subscribe(resp => {
      }, err => {
      })
    }
  }

  getJourneyDetails(ev?) {
    // this.first_login_details = this.session_service.getMyJourneyDetails();
    // 1 - Active , 2-Readonly , 3-Disabled ,4 - Inactive
    this.refresh_flag = 0;
    this.http.get('assets/config/my-journey.json').subscribe((res: any) => {
      if (res && res.steps && res.steps.length) {
        let first_step;
        this.refresh_flag = 1;
        res.steps.forEach((step, index) => {
          if (!first_step) {
            first_step = step;
            this.current_step = {
              type: step.type,
              session: null,
              index: index
            }
          }
          if (this.first_login_details[step.property_name]) {
            step.status = 1;
            if (step.exclude) {
              // if (!first_step) {
              //   first_step = step;
              //   this.current_step = {
              //     type: step.type,
              //     session: null,
              //     index: index
              //   }
              // }
            }
            else {
              this.current_step = {
                type: step.type,
                session: null,
                index: index
              }
              res.steps.forEach(res => {
                if (step.type > res.type) {
                  res.status = 2;
                }
              })
            }
          }
          else {
            step.status = 3;
          }
        })  
        if (!(this.current_step && this.current_step.type)) {
          this.current_step = {
            type: first_step.type,
            session: null,
            index: first_step.index
          }
        }
        this.steps = res.steps;
        setTimeout(() => {
          this.setActiveHeader(0)
          // this.step_header_element = document.getElementById('step-headers' + this.id);
        })
        // try {
        //   this.observer().unobserve(document.getElementById(this.id));
        //   this.observer().observe(document.getElementById(this.id));
        // } catch (error) {
        //   this.observer().observe(document.getElementById(this.id));
        // }
      }
    })
  }

  setActiveHeader(index) {
    setTimeout(() => {
      let activeItem = document.querySelector('.tabs .active');
      let width = activeItem.getBoundingClientRect().width;
      // let left = activeItem.getBoundingClientRect().left;

      let elem = document.querySelector('.selector');
      elem['style']['left'] = activeItem['offsetLeft'] - (activeItem.scrollLeft) + activeItem.clientLeft + 'px';
      elem['style']['width'] = width + 'px';
    });
    // console.log(tabs);
    // console.log(activeItem);

    // let activeWidth = activeItem.offsetWidth;
    // $(".selector").css({
    //   "left": activeItem.position['left'] + "px",
    //   "width": activeWidth + "px"
    // });
  }
  // observer() {
  //   return new IntersectionObserver((entries) => {
  //     // isIntersecting is true when element and viewport are overlapping
  //     // isIntersecting is false when element and viewport don't overlap
  //     if (this.step_header_element) {
  //       if (entries && entries[0] && entries[0].isIntersecting === true) {
  //         this.step_header_element.classList.remove('sticky-element');


  //         // console.log('Element has just become visible in screen');
  //       }
  //       else {
  //         this.step_header_element.classList.add('sticky-element');
  //         // console.log('Element has just become not visible in screen');
  //       }
  //     }
  //   },5 { threshold: [0] });
  // }

}
